import React from 'react';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import LeadInsightField from './LeadInsightField';

// Frase que disparou o insight — texto livre da IA, por isso é limitado a
// algumas linhas em vez de crescer o card indefinidamente.
const LeadTrigger = ({ trigger }) => {
  const { t } = useTranslation();

  if (!trigger) return null;

  return (
    <LeadInsightField label={t('leads.trigger')}>
      <Typography
        variant="body2"
        color="text.secondary"
        fontStyle="italic"
        sx={{
          display: '-webkit-box',
          WebkitLineClamp: 3,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
        }}
      >
        &quot;{trigger}&quot;
      </Typography>
    </LeadInsightField>
  );
};

export default LeadTrigger;
